import React from "react";
import { FormElements } from "../../../../../../../shared/bootstrap/form/FormElements";
import { useLanguageForShared } from "../../../../../../../shared/utils/languages/useLanguageForShared";

const tipoPrescrizioneOptions = (t) => [
  { label: t("voxiSud.tipoPrescrizione.prima"), value: "prima" },
  { label: t("voxiSud.tipoPrescrizione.successiva"), value: "successiva" },
  { label: t("voxiSud.tipoPrescrizione.definitiva"), value: "definitiva" },
  { label: t("voxiSud.tipoPrescrizione.temporanea"), value: "temporanea" },
  { label: t("voxiSud.tipoPrescrizione.altro"), value: "altro" }
];

const VoxiSudFooter = ({ dataForm, changeValue, errors, isSubmit }) => {
  const { t } = useLanguageForShared();

  const formStructure = [
    {
      name: "validUntil",
      type: "input",
      label: `${t("prescription.template.validUntil")}*`,
      dataElement: { type: "date" },
      extra: {
        type: "datePicker",
        settings: { drops: "auto" }
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    },
    {
      name: "dataProssimoControllo",
      type: "input",
      label: `${t("voxiSud.dataProssimoControllo")}*`,
      dataElement: { type: "date" },
      extra: {
        type: "datePicker",
        settings: { drops: "auto" }
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    },
    {
      name: "tipoPrescrizione",
      type: "select",
      label: `${t("voxiSud.tipoPrescrizione.label")}*`,
      options: tipoPrescrizioneOptions(t),
      dataElement: { type: "text" },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    }
  ];

  return (
    <FormElements
      structure={formStructure}
      dataForm={dataForm}
      changeValue={changeValue}
      errors={errors}
      isSubmit={isSubmit}
    />
  );
};

export default VoxiSudFooter;
